
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SurfaceZonificationItem from './SurfaceZonificationItem.vue';
import { NDVIInfo, ZonificationInfo } from '../../../../typescript/satellital/layers';

@Component({
  components: {
    SurfaceZonificationItem,
  },
})
export default class SurfaceZonificationInfo extends Vue {
  @Prop({
    default: () => ({
      date: null,
      png_url: null,
      bar_url: '',
      total_area: null,
      zones: [],
      bounds: null,
    }),
  })
  zonifiedInfo!: ZonificationInfo;

  @Prop({
    default: () => ({
      initial_date: null,
      final_date: null,
      png_url: null,
      bar_url: '',
      total_area: null,
      zones: [],
      bounds: null,
    }),
  })
  ndviInfo!: NDVIInfo;

  /** Open by default so surface info remains visible on load */
  surfacePanel: number = 0;

  currentZonified: ZonificationInfo = {
    date: null,
    png_url: null,
    bar_url: '',
    total_area: null,
    zones: [],
    bounds: null,
  };

  currentNdvi: NDVIInfo = {
    initial_date: null,
    final_date: null,
    png_url: null,
    bar_url: '',
    total_area: null,
    zones: [],
    bounds: null,
  };

  mounted() {
    this.currentZonified = this.zonifiedInfo || this.currentZonified;
    this.currentNdvi = this.ndviInfo || this.currentNdvi;
  }

  @Watch('zonifiedInfo', { immediate: true, deep: true })
  onZonifiedInfoChanged(info: ZonificationInfo) {
    if (info) {
      this.currentZonified = info;
    }
  }

  @Watch('ndviInfo', { immediate: true, deep: true })
  onNdviInfoChanged(info: NDVIInfo) {
    if (info) {
      this.currentNdvi = info;
    }
  }

  getSumZ(): SurfaceZonificationItem | null {
    const r = this.$refs.sumZ;
    return ((Array.isArray(r) ? r[0] : r) as SurfaceZonificationItem) || null;
  }

  getSumN(): SurfaceZonificationItem | null {
    const r = this.$refs.sumN;
    return ((Array.isArray(r) ? r[0] : r) as SurfaceZonificationItem) || null;
  }

  updateLayersInfoZonified(info: ZonificationInfo) {
    this.currentZonified = info || {
      date: null,
      png_url: null,
      bar_url: '',
      total_area: null,
      zones: [],
      bounds: null,
    };
    const sumZ = this.getSumZ();
    if (sumZ) {
      sumZ.updateLayersInfo(this.currentZonified);
    }
  }

  updateLayersInfoNdvi(info: NDVIInfo) {
    this.currentNdvi = info || {
      initial_date: null,
      final_date: null,
      png_url: null,
      bar_url: '',
      total_area: null,
      zones: [],
      bounds: null,
    };
    const sumN = this.getSumN();
    if (sumN) {
      sumN.updateLayersInfo(this.currentNdvi as unknown as ZonificationInfo);
    }
  }

  updateLoadingZonification(value: boolean) {
    const sumZ = this.getSumZ();
    if (sumZ) {
      sumZ.updateLoadingIndicator(value);
    }
  }

  updateLoadingNdviDiff(value: boolean) {
    const sumN = this.getSumN();
    if (sumN) {
      sumN.updateLoadingIndicator(value);
    }
  }
}
